import { takeEvery, all, call, put } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { MEMBER_REGISTER_NSMODAL__BY_PASS_PHRASE, RegisterNSModalByPassPhraseAction } from 'app/store/features/member/register/nsModal/types';
import { sagaBoundary } from 'app/store/service';
import apiService from 'app/bff/services/apiService';
import commonService from 'app/core/services/commonService';
import modalService from 'app/core/services/modalService';
import { AaSigninResp } from 'app/bff/models/aa/aaSignin';
import { MbGetinfoResp } from 'app/bff/models/mb/mbGetinfo';
import { UserIdentityTypesEnum } from 'app/bff/enums/user';
import { ROUTES } from 'app/core/router/paths';
import { fetchMemberProfileDoneAction } from 'app/store/features/member/register/auth/actions';
import { ProcessRouteMatchesStep as PermissionProcessRouteMatchesStep } from 'app/features/Member/Register/Permission/types';
import { setAccessibleStepAction as setPermissionAccessibleStepAction } from '../permission/actions';
import { ModalNamesEnum } from 'app/core/enums/ui/modals';

/**
 * @description 網服會員驗證入口
 */
function * registerByPassPhraseNSModal (action: RegisterNSModalByPassPhraseAction) {
  const response: AaSigninResp = yield call(apiService.postAaSignin, {
    ...action.payload.authMemberArgs
  });
  if (response && response.userResult === 'SUCCESS') {
    const memberInfo: MbGetinfoResp = yield call(apiService.postMbGetinfo, { users: { VERIFY_TOKEN: response.token } });
    const decryptedMemberInfo = commonService.decryptMemberInfo(memberInfo);
    yield put(fetchMemberProfileDoneAction(decryptedMemberInfo));
    if (decryptedMemberInfo.userStatus.userType === UserIdentityTypesEnum.NS) {
      // 將「同意相關告知事項」(Step-1) 設為可訪問步驟
      yield put(setPermissionAccessibleStepAction(PermissionProcessRouteMatchesStep[ROUTES.MEMBER__REGISTER__PERMISSION__CLAUSES]));
      // 導頁至「同意相關告知事項」(Step-1)
      yield put(push(ROUTES.MEMBER__REGISTER__PERMISSION__CLAUSES));
    } else {
      modalService.base('系統提醒', '非網服會員或已是網投會員');
    }
    // 關閉「網服會員身份驗證」modal
    modalService.trigger(ModalNamesEnum.MemberRegisterNSModal, false);
  }
}

export default function * watchNSModalSaga () {
  yield all([
    takeEvery(MEMBER_REGISTER_NSMODAL__BY_PASS_PHRASE, sagaBoundary(registerByPassPhraseNSModal))
  ]);
}
